import React from 'react';
import { Palette } from 'lucide-react';
import ThemeSettings from '../ThemeSettings';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';

export const ThemeDialog = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="flex flex-col items-center gap-2 p-4 bg-slate-800/50 rounded-2xl hover:bg-slate-800 transition-colors border border-slate-700/50">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-pink-500 to-rose-600 flex items-center justify-center">
            <Palette className="h-5 w-5 text-white" />
          </div>
          <span className="text-sm text-white">Theme</span>
        </button>
      </DialogTrigger>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-pink-500 to-rose-600 flex items-center justify-center">
              <Palette className="h-4 w-4 text-white" />
            </div>
            Theme Settings
          </DialogTitle>
        </DialogHeader>
        <ThemeSettings />
      </DialogContent>
    </Dialog>
  );
};

export default ThemeDialog;
